import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import ClientPropOne from "./ClientPropOne";
import ProjectData from "../../data/client/ClientData.json";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ClientSlider = ({ parentClass, colSize, itemShow = 3, columnGap }) => {
  const [sliderRef, setSliderRef] = useState(null);
  const [isTabletOrBelow, setIsTabletOrBelow] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsTabletOrBelow(window.innerWidth <= 1024);
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: itemShow,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 500,
    arrows: true,
    className: "client-slides",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(3, itemShow),
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: Math.min(2, itemShow),
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className={`section ${!isTabletOrBelow ? "section-padding-3" : ""} ${parentClass || ""}`}>
      <div className="container">
        <div className="client-slider">
          {/* <div className="slider-navigation">
            <div className="navigation-wrapper">
              <button className="custom-prev-arrow" onClick={() => sliderRef?.slickPrev()}>
                <span>&larr;</span>
              </button>
              <button className="custom-next-arrow" onClick={() => sliderRef?.slickNext()}>
                <span>&rarr;</span>
              </button>
            </div>
          </div> */}
          <Slider ref={setSliderRef} {...settings}>
            {ProjectData.map((data) => (
              <div key={data.id} className="client-slide-item">
                {/* <div className="slide-content"> */}
                <ClientPropOne projectStyle="" portfolio={data} />
                {/* </div> */}
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default ClientSlider;
